import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import { ArrowLeft, TrafficCone } from "lucide-react";
import { CityHeader } from "@/components/CityHeader";
import { PilotBanner } from "@/components/PilotBanner";

export default function TrafficModule() {
  const [, navigate] = useLocation();

  return (
    <div className="min-h-screen bg-background">
      <CityHeader />
      <PilotBanner />
      
      <div className="container py-8">
        <div className="flex items-center gap-4 mb-6">
          <Button variant="ghost" size="icon" onClick={() => navigate("/")}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold">Traffic Department</h1>
            <p className="text-muted-foreground">Signal Maintenance Module</p>
          </div>
        </div>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-amber-100 rounded-lg">
                <TrafficCone className="h-8 w-8 text-amber-600" />
              </div>
              <div>
                <CardTitle>Traffic Signal Maintenance</CardTitle>
                <CardDescription>
                  Operational records platform for traffic signal maintenance and monitoring
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-center py-16 space-y-4">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-muted">
                <TrafficCone className="h-10 w-10 text-muted-foreground" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Module Coming Soon</h3>
                <p className="text-muted-foreground max-w-md mx-auto">
                  The Traffic Signal Maintenance module is currently under development. 
                  This module will provide comprehensive logging and tracking capabilities 
                  for traffic signal infrastructure maintenance.
                </p>
              </div>
              <div className="pt-4">
                <p className="text-sm text-muted-foreground">
                  Expected features:
                </p>
                <ul className="text-sm text-muted-foreground mt-2 space-y-1 max-w-md mx-auto">
                  <li>• Signal inspection logs</li>
                  <li>• Maintenance work orders</li>
                  <li>• Equipment inventory tracking</li>
                  <li>• Outage reporting and response</li>
                  <li>• Timing and cycle documentation</li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
